import { useQuery } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { getUrlParamsFetch } from '@/shared';
import { SolicitudesEgreso } from '@/shared/interfaces/erp/compras/solicitudes-egreso.interface';

const { get } = erpApi();

export type GetTrazabilidadPedidoParams = {
  page?: number;
  page_size?: number;
  estado?: string;
  solicitud_egreso?: string;
};

export type TrazabilidadPedido = {
  id: string;
  solicitud_egreso: string;
  producto_codigo: string;
  producto_data: any;
  cantidad: string;
  estado: string;
  motivo_rechazo: string | null;
  observacion: string | null;
  fecha_creacion: string;
  solicitud_egreso_data: SolicitudesEgreso
};

export type TrazabilidadPedidoPagingRes = {
  data: TrazabilidadPedido[];
  count: number;
};

export const GetTrazabilidadPedido = async (params?: GetTrazabilidadPedidoParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<TrazabilidadPedidoPagingRes>(
    `${urlBackend}api/v1/trazabilidad-pedido/?${queryParams}`,
    true
  );
};

export const useFetchTrazabilidadPedido = (params?: GetTrazabilidadPedidoParams) => {
  return useQuery({
    queryKey: ['trazabilidad-pedido', ...Object.values(params || {})],
    queryFn: async () => GetTrazabilidadPedido(params),
  });
};
